const extractAddressParts = (placeDetails) => {
  const components = placeDetails?.address_components || [];

  const get = (type) =>
    components.find((c) => c.types.includes(type))?.long_name || "";

  return {
    fullAddress: placeDetails.formatted_address,
    street: `${get("street_number")} ${get("route")}`.trim(),
    city: get("locality") || get("sublocality") || get("postal_town"),
    province: get("administrative_area_level_1"),
    postalCode: get("postal_code"),
    country: get("country"),
    coordinates: {
      lat: placeDetails.geometry.location.lat(),
      lng: placeDetails.geometry.location.lng(),
    },
    placeId: placeDetails.place_id,
  };
};

export default extractAddressParts;
